import React, { useState, useCallback } from "react";
import GlobalQuickJump from "../../../global/GlobalQuickJump";
import PaymentPurposesMaster from "../components/masters/PaymentPurposesMaster";

import "../../user-builder/styles/userBuilder.css";
import "../../user-builder/styles/UserBuilderPage.css";
import "../styles/FinanceAndPayments.css";

const FinancePaymentsControlPage = () => {
  const [activeQuickJump, setActiveQuickJump] = useState(null);
  const bumpFinanceMasters = useCallback(() => {}, []);

  const QUICK_JUMP_ITEMS = [
    { key: "payment", label: "Payment", targetId: "fp-payment" },
  ];

  return (
    <div className="user-builder-shell">
      <header className="user-builder-hero">
        <div className="user-builder-hero__text">
          <p className="user-builder-hero__eyebrow">Administrative Area</p>
          <h2 className="user-builder-hero__title">Finance &amp; payments</h2>
          <p className="user-builder-hero__sub">
            Maintain payment purposes used across collection flows. Payments are
            recorded as online (PhonePe) or offline only. Payment success vs
            pending and verification are stored as booleans on each payment row.
            The collector on each payment is the signed-in user automatically.
            Cheque-related masters are under Admin → Office Records → Cheque Issues.
          </p>
        </div>
      </header>

      <div className="user-builder-layout">
        <div className="user-builder-layout__main">
          <div
            id="fp-masters"
            className="user-builder-panel"
            style={{ scrollMarginTop: "2rem" }}
          >
            <div className="user-builder-panel__head">
              <h3 className="user-builder-panel__title">
                Master table management
              </h3>
              <p className="user-builder-panel__hint">
                Configure payment purpose lookups used when saving payments.
              </p>
            </div>
            <div className="finance-fp-stack">
              <div id="fp-payment">
                <div
                  id="fp-purposes"
                  className="finance-fp-master-block finance-fp-master-block--first"
                >
                  <PaymentPurposesMaster
                    onDirectoryChange={bumpFinanceMasters}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <GlobalQuickJump
          asideAriaLabel="Finance master sections"
          items={QUICK_JUMP_ITEMS}
          activeKey={activeQuickJump}
          onActiveKeyChange={setActiveQuickJump}
        />
      </div>
    </div>
  );
};

export default FinancePaymentsControlPage;
